export default {
  meta: {
    title: '标准模型推荐详情',
    parentPath: ['/recommend'],
    breadcrumbs: {
      path: ['/recommend/modal'],
      name: ['开店区域推荐'],
    },
  },
};
